<div
  ngbDropdown
  placement="bottom"
  class="dropdown-container"
  (openChange)="onOpenChange($event)"
>
  <button
    (click)="onBlur()"
    [disabled]="disabled()"
    ngbDropdownToggle
    class="btn btn-outline-secondary form-control dropdown-button"
    [ngClass]="{ 'is-invalid': isInvalid() && !ddIsOpen() }"
    type="button"
  >
    @if (!dropdownOption() || dropdownOption().text === '') {
      <span>{{ placeHolder() }}</span>
    }
    @if (dropdownOption()) {
      <span>{{ dropdownOption().text }}</span>
    }
  </button>
  <div ngbDropdownMenu class="dropdown-menu">
    @if (filterable()) {
      <div [formGroup]="f">
        <div class="form-group px-2 m-0">
          <input
            #ddFilter
            tabindex="0"
            class="form-control"
            formControlName="filterInput"
            (keyup)="onKeyUp()"
          />
          <hr class="px-1 mb-1" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="currentColor"
            class="bi bi-search inner-addon"
            viewBox="0 0 16 16"
          >
            <path
              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
            />
          </svg>
        </div>
      </div>
    }
    @for (item of displayData(); track item) {
      <div>
        @if (item.value !== '') {
          <button
            ngbDropdownItem
            class="dropdown-item"
            type="button"
            (click)="onSelect(item)"
          >
            <ngb-highlight
              [result]="item.text"
              [term]="f.get('filterInput').value"
            ></ngb-highlight>
          </button>
        }
      </div>
    }
  </div>
</div>
